import { Component } from '@angular/core';

@Component({
  selector: 'areasDeIntervencion',
  templateUrl: './areasDeIntervencion.component.html',
  styleUrls: ['./areasDeIntervencion.component.css']
})
export class AreasDeIntervencionComponent {
}
